import { MiniCardProps } from "../types";

/**
 * Re-orders mini cards to display optimally for the smaller gathering header.
 */
const loopMiniCardOrder = (miniCards: MiniCardProps[]): MiniCardProps[] => {
	return [miniCards[0], ...miniCards.slice(3), miniCards[2], miniCards[1]].filter(
		(miniCard): miniCard is MiniCardProps => miniCard !== undefined,
	);
};
export default loopMiniCardOrder;
